/**
 * channelNotCompatibleModal.tsx
 */
import ChannelDown from '../../elements/images/channelDown';
import ChannelUp from '../../elements/images/channelUp';
import Container from '../../atoms/container/modalContainer';
import DeviceConfig from '@devices/config';
import Error from '../../atoms/container/errorContainer';
import Focus from '@shared/types/enums/focus';
import QrContainer from '../../atoms/container/deviceNotCompatibleModalQrContainer';
import QrGenerator from '../../elements/qr/qrGenerator';
import Subtitle from '../../atoms/text/modalSubtitle';
import SupportUrlText from '../../atoms/text/modalSupportUrlText';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { channelDown, channelUp } from '@shared/store/thunks/channels.thunk';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { popFocus, pushFocus } from '@shared/store/slices/focus.slice';
import { popRoute } from '@shared/store/thunks/route.thunk';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useEffect } from 'react';
import LogoContainer from '@components/atoms/container/notAllowedChannelLogoContainer';
import ChannelLogo from '@components/atoms/images/channelLogo';

/**
 * Displays the channel not compatible modal, shown when the current channel
 * cannot be played on this device.
 */
export default function ChannelNotCompatibleModal() {
  const dispatch = useAppDispatch();
  const { currentChannel } = useAppSelector(channelsSelector);
  const { supportUrl } = DeviceConfig.capabilities;

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  useKeyboard({
    canBeFocused: false,
    keyDownHandler: (key) => {
      switch (key) {
        case 'UP':
        case 'CHANNEL_UP':
          dispatch(channelUp());
          break;
        case 'DOWN':
        case 'CHANNEL_DOWN':
          dispatch(channelDown());
          break;
        case 'BACK':
          dispatch(popRoute());
      }
    },
  });

  return (
    <Container>
      <ChannelUp />
      <Error>
        <LogoContainer onTop>
          <ChannelLogo src={currentChannel?.logo} position='none' />
        </LogoContainer>{' '}
        <Subtitle>
          {TranslationManager.get('MODAL.CHANNEL_NOT_COMPATIBLE.BODY')}
          <br></br>
          <br></br>
          {TranslationManager.get('MODAL.CHANNEL_NOT_COMPATIBLE.BODY_2')}{' '}
          <br></br>
          <br></br>
        </Subtitle>
        {supportUrl ? (
          <QrContainer>
            <QrGenerator scale={1.4} url={supportUrl} />
          </QrContainer>
        ) : null}
        {supportUrl ? <SupportUrlText>{supportUrl}</SupportUrlText> : null}
      </Error>
      <ChannelDown />
    </Container>
  );
}
